import { data } from "../api.ts";
import { Cartao, Selo } from "../componentes/basicos.tsx";
import { useDados } from "../usarDados.ts";

type Chave = {
  kid: string; estado: string; impressao_curta: string; algoritmo: string;
  criada_em: string; aposentada_em: string | null;
  tokens_vivos: number; tokens_total: number;
};

export function Chaves() {
  const { dados, erro, carregando } = useDados<Chave[]>("/chaves");

  return (
    <>
      <h1>Chaves de assinatura</h1>

      <div className="alerta">
        <span className="alerta__titulo">Onde fica a chave privada</span>
        Nunca no banco: e um arquivo no servidor, com permissao restrita, entregue ao
        servico pelo ambiente. Aqui aparece so a parte publica. Confira a impressao
        com a que o comando de rotacao imprimiu.
      </div>

      <Cartao titulo="Chaves">
        {carregando && <div className="carregando">carregando...</div>}
        {erro && <div className="alerta alerta--erro">{erro}</div>}
        {dados && (
          <div className="tabela-rolagem">
            <table className="tabela">
              <thead>
                <tr>
                  <th>Identificador</th><th>Estado</th><th>Impressao</th><th>Algoritmo</th>
                  <th className="tabela__num">Tokens vivos</th><th className="tabela__num">Ja emitidos</th>
                  <th>Criada</th><th>Aposentada</th>
                </tr>
              </thead>
              <tbody>
                {dados.map((c) => (
                  <tr key={c.kid}>
                    <td className="tabela__mono">{c.kid}</td>
                    <td>
                      {c.estado === "ativa" ? <Selo tom="ok">assinando</Selo>
                        : c.estado === "aposentando" ? <Selo tom="aviso">aposentando</Selo>
                        : <Selo tom="neutro">revogada</Selo>}
                    </td>
                    <td className="tabela__mono">{c.impressao_curta}</td>
                    <td className="suave pequeno">{c.algoritmo}</td>
                    {/* E o numero que diz se uma chave 'aposentando' ja pode ser
                        revogada. Sem ele, "aposentando" e um estado sem condicao
                        de saida visivel. */}
                    <td className="tabela__num">
                      {c.tokens_vivos > 0
                        ? <strong>{c.tokens_vivos}</strong>
                        : <span className="suave">nenhum</span>}
                    </td>
                    <td className="tabela__num suave">{c.tokens_total}</td>
                    <td className="suave pequeno">{data(c.criada_em)}</td>
                    <td className="suave pequeno">{data(c.aposentada_em)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {dados && dados.some((c) => c.estado === "aposentando" && c.tokens_vivos === 0) && (
          <p className="suave pequeno mb-0">
            Ha chave aposentando sem nenhum token vivo: ja pode ser revogada.
          </p>
        )}
      </Cartao>

      <Cartao titulo="Rotacionar">
        <p className="suave pequeno">
          A rotacao acontece no servidor, nao por esta tela, porque grava um arquivo de
          chave privada em disco. Um endpoint HTTP com essa permissao e superficie que
          nao vale a pena existir.
        </p>
        <pre className="bloco-comando">{`cd /opt/licencas/api
npm run rotacionar-chave -- --kid k2
# depois: LICENCAS_KID_ATIVO=k2 no ambiente e pm2 restart licencas-api`}</pre>
        <p className="suave pequeno mb-0">
          A chave antiga vira <span className="tabela__mono">aposentando</span>, e nao
          revogada: os tokens ja emitidos continuam valendo ate vencerem, e revogar de
          imediato derrubaria a base instalada no ato. Nao apague o arquivo dela enquanto
          houver cliente que so conhece essa chave -- e com ela que o servidor tambem
          assina o conjunto de chaves que o cliente precisa passar a aceitar.
        </p>
      </Cartao>
    </>
  );
}
